import { initialStateOptions } from '@/utils/pagination-utils';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  centrosCustos: [],
  solicitantes: [],
  produto: [],
  projeto: [],
  searchText: null,
  empresa: null,
  localEntrega: null,
  grupo: [],
  dataInicial: null,
  dataFinal: null,
  dataEntregaInicial: null,
  dataEntregaFinal: null,
  urgencia: [],
  showEspecificacao: false,
  showObservacaoInterna: false,
  showObservacaoExterna: false,
  compradores: [],
  listOptions: initialStateOptions(),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
